module.exports = __webpack_public_path__ + "static/img/questionnaires.8bdc747d.svg";